import arrayReduce from './arrayReduce';

export default function processStyleWithPlugins(renderer, style, type) {
  var props = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

  if (renderer.plugins.length > 0) {
    return arrayReduce(renderer.plugins, function (processedStyle, plugin) {
      processedStyle = plugin(processedStyle, type, renderer, props);
      return processedStyle;
    }, style);
  }

  return style;
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/fela-utils/es/processStyleWithPlugins.js
// module id = 258
// module chunks = 0